// Outlook-agenda voor Slim Uren (tool-feedback #64, okt 2026: "week 41 wil niet laden").
// Twee oorzaken: (a) elke stille tokenfout gaf een popup die de browser blokkeerde, en
// (b) calendarView met $top=50 volgde @odata.nextLink niet, zodat een drukke week halverwege
// ophield. Hier: pagineren zoals de mail-fetch, en een foutmelding die zegt wát er misging.

export const MAX_AGENDA_PAGINAS = 10;   // 10 × 100 = 1000 afspraken per week, ruim genoeg

export function agendaUrl(startDT, endDT) {
    return `https://graph.microsoft.com/v1.0/me/calendarView?startDateTime=${startDT}&endDateTime=${endDT}`
        + '&$top=100&$orderby=start/dateTime&$select=subject,start,end,isAllDay,isCancelled,showAs,attendees,bodyPreview';
}

// Alle afspraken in het venster, over alle pagina's. Gooit bij een fout (de aanroeper meldt hem).
export async function haalAgendaOp(token, startDT, endDT, fetchFn = fetch) {
    let next = agendaUrl(startDT, endDT);
    let events = [];
    for (let pagina = 0; next && pagina < MAX_AGENDA_PAGINAS; pagina += 1) {
        const res = await fetchFn(next, {   // eslint-disable-line no-await-in-loop
            headers: { Authorization: `Bearer ${token}`, Prefer: 'outlook.timezone="Europe/Amsterdam"' },
        });
        if (!res.ok) {
            const err = new Error(`Outlook-agenda gaf ${res.status}`);
            err.status = res.status;
            throw err;
        }
        const json = await res.json();   // eslint-disable-line no-await-in-loop
        events = events.concat(json.value || []);
        next = json['@odata.nextLink'] || null;
    }
    return events;
}

// Begrijpelijke melding voor de gebruiker, per soort fout.
export function agendaFoutmelding(err) {
    const code = String(err?.errorCode || err?.code || '');
    const msg = String(err?.message || '');
    const basis = 'Outlook-agenda kon niet geladen worden, dus de voorstellen zijn alleen op je taken gebaseerd.';
    if (/popup_window_error|empty_window_error|popup/i.test(code) || /popup/i.test(msg)) {
        return `${basis} De browser blokkeerde het inlogvenster van Microsoft: sta pop-ups toe voor deze site en klik opnieuw op Genereer.`;
    }
    if (/user_cancelled/i.test(code)) {
        return `${basis} Het inlogvenster van Microsoft werd gesloten: klik opnieuw op Genereer en log in.`;
    }
    if (err?.status === 401 || err?.status === 403 || /interaction_required|consent_required|login_required/i.test(code)) {
        return `${basis} Je moet opnieuw toestemming geven voor je agenda: klik opnieuw op Genereer en volg het inlogvenster.`;
    }
    if (err?.status === 429 || (err?.status >= 500 && err?.status < 600)) {
        return `${basis} Outlook reageerde niet (${err.status}); probeer het over een minuut opnieuw.`;
    }
    return `${basis} (${msg || 'onbekende fout'})`;
}
